import React from 'react';
import ActionsDropdown from '../ActionsDropdown/ActionsDropdown';
import { ModalStateProvider } from '../../model/modalState';
import { SelectedParamProvider } from '../../model/selectedParam';
import ModalFactory from '../ModalFactory/ModalFactory';
import { useAllowMassActions } from '../../utils/allowMassActions';

const MainComponent = ({ actionStyle, requests, onSuccess }) => {
  const allowMassActions = useAllowMassActions();

  if (!allowMassActions) return null;

  return (
    <ModalStateProvider>
      <SelectedParamProvider>
        <ActionsDropdown actionStyle={actionStyle} />
        <ModalFactory
          requests={requests}
          onSuccess={onSuccess}
        />
      </SelectedParamProvider>
    </ModalStateProvider>
  );
};

export default MainComponent;
